module.exports = __webpack_public_path__ + "img/ps-3.79f0ed51.webp";